/* Cleaning Day v2 — shared behaviour for the cd2-* sections.
   Reveal-on-scroll for .cd2-rv elements and the longevity bars ([data-cd2-decay]). */
(function () {
  'use strict';

  function scan() {
    var els = document.querySelectorAll('.cd2-rv:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-in');
        if (el.hasAttribute('data-cd2-decay')) el.classList.add('is-play');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          if (e.target.hasAttribute('data-cd2-decay')) e.target.classList.add('is-play');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.18 });
    els.forEach(function (el) { io.observe(el); });
  }

  window.cd2Scan = scan;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /* Re-scan when the theme editor re-renders a section */
  document.addEventListener('shopify:section:load', scan);
})();
